import script from "./RepaymentsScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./RepaymentsScreen.vue?vue&type=script&setup=true&lang=js"

import "./RepaymentsScreen.vue?vue&type=style&index=0&id=62be7d27&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62be7d27"]])

export default __exports__